"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_redux_1 = require("react-redux");
const roomCreateStore_1 = require("@/room/room_create/roomCreateStore");
const _1 = require(".");
const react_hook_form_1 = require("react-hook-form");
const react_i18next_1 = require("react-i18next");
const styled_1 = __importDefault(require("@emotion/styled"));
const Button_1 = __importDefault(require("@mui/material/Button"));
function default_1() {
    const questions = (0, react_redux_1.useSelector)((state) => state.roomData.questions);
    const { t } = (0, react_i18next_1.useTranslation)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const { control, formState: { errors }, } = (0, react_hook_form_1.useForm)({ mode: 'onChange' });
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [questions.map((questionData, index) => {
                return ((0, jsx_runtime_1.jsx)(_1.AdditionalQuestionInput, { questionData: questionData, index: index, control: control, errors: errors }, `${index}_${questionData.content}`));
            }), questions.length < 5 && ((0, jsx_runtime_1.jsx)("div", Object.assign({ style: { marginBottom: '20px', textAlign: 'right' } }, { children: (0, jsx_runtime_1.jsx)(AddButton, Object.assign({ onClick: () => dispatch((0, roomCreateStore_1.addAdditionQuestion)()) }, { children: (0, jsx_runtime_1.jsxs)("span", Object.assign({ className: "subtitle4" }, { children: ["+ ", t('질문 추가')] })) })) })))] }));
}
exports.default = default_1;
const AddButton = (0, styled_1.default)(Button_1.default) `
  height: 32px;
  padding: 0 12px;
  border: 1px solid var(--gray-80);
  border-radius: 6px;
  background-color: var(--white) !important;
  color: var(--gray-80);
`;
